function numberToDecimalPlace(number, decimalPlace = 2) {
  if (!number) return '0,00'
  return number.toLocaleString('pt-br', { minimumFractionDigits: decimalPlace })
}

export default numberToDecimalPlace;
